import React from "react";
import axios from "axios";
import parseHtml from "html-react-parser";
import Header from "./Header.jsx";
import { useNavigate } from "react-router-dom";
import Loader from "./shares/Loader.jsx";
import bobathanks from "../boba_thanks.png";
import bobablock from "../boba_block.png";
import exambpp from "../EXAMBPPP-logo.png";
import { encrypt, decrypt_res } from "./shares/GlobalFunction.jsx";
import { API_URL, SECRET_SESSION } from "../constants";
import { useLocation } from "react-router-dom";
const baseURL = API_URL + "/login/info";

const Blocked = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {state} = location;

  React.useEffect(() => {
    axios.post(baseURL).then((response) => {
      response.data.res = JSON.parse(
        decrypt_res(response.data.res, SECRET_SESSION)
      );

      // alert(response.data.res.browser);

      if (state && state.userAgent) {
        const userAgent = navigator.userAgent;
        const browserIdentity = process.env.REACT_APP_BROWSER_IDENTITY;
        if (userAgent.includes(browserIdentity)) {
          navigate("/");
          return false;
        }
      } else {
        navigate("/");
        return false;
      }
    });
  }, []);

  const winButton = () => {
    window.location.href = "https://exam.bppp.kemdikbud.go.id/win"
  }
  const macButton = () => {
    window.location.href = "https://exam.bppp.kemdikbud.go.id/mac"
  }
  return (
    <div className="App">
      <div 
        className="App-header flex flex-row"
        style={{backgroundColor: "white"}}
        >
        <Header />
        
        <div className="w-1/4 h-screen"></div>
        <div className="flex flex-col h-screen justify-center w-[100%] px-20 overflow-y-hidden relative bg-color">
          <div className="flex flex-col">
            <p
              className="bg-white border border-b-8 my-4 mx-6 font-bold text-center border-[#BA2120] bb-10 text-red-700 px-6 py-3 rounded-md relative"
            >
              Ujian ini hanya bisa diakses melalui ExamBPPP versi terbaru
            </p>
            <div className="flex flex-row">
            <iframe className="z-10 w-full" width="720" height="420" src="https://www.youtube.com/embed/ghX27PUqo08" title="Panduan Instalasi ExamBPPP untuk Sistem Operasi WINDOWS" frameborder="100" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <div className="w-20"></div>
            <iframe className="z-10 w-full" width="720" height="420" src="https://www.youtube.com/embed/oLkhz6rpAO8" title="Panduan Instalasi ExamBPPP untuk Sistem Operasi WINDOWS" frameborder="100" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
          <div
            className="z-10 overflow-y-hidden relative"
            style={{
              minHeight: "200px",
              animation: "fadeInFromBottom 1s forwards",
            }}
          >
            <img
              src={exambpp}
              className="h-16 sm:h-24 md:h-24 lg:h-32 xl:h-16"  
            ></img>
            <div
              className="relative"
              style={{
                fontSize: "20px",
                fontFamily: '"Poppins", sans-serif',
                marginTop: "10px"
              }}>

                <p style={{fontWeight: 400, marginBottom: "10px"}}>Mohon untuk mengunduh install exambppp versi terbaru melalui link berikut</p>
              
            </div>
            <div className="flex flex-col" style={{justifyContent: "space-between"}}>
              {/* <div
              onClick={winButton}
                style={{backgroundColor: "#4F8382"}}
                type="button"
                id="btnSubmit"
                className="bg-blue-500 hover:bg-blue-800 text-white py-2 w-1/3 rounded-full"
              >
                Windows: 1.12
              </div> */}
              <div
              className="relative"
              style={{
                fontSize: "20px",
                fontFamily: '"Poppins", sans-serif',
                marginTop: "10px"
              }}>
                <p><strong>Windows</strong>: <i>https://exam.bppp.kemdikbud.go.id/win</i></p>
              </div>
              <div
              className="relative"
              style={{
                fontSize: "20px",
                fontFamily: '"Poppins", sans-serif',
                marginTop: "10px"
              }}>
                <p><strong>Mac/Apple</strong>: <i>https://exam.bppp.kemdikbud.go.id/mac</i></p>
              </div>
              {/* <button
                onClick={macButton}
                style={{backgroundColor: "#4F8382"}}
                type="button"
                id="btnSubmit"
                className="bg-blue-500 hover:bg-blue-800 text-white py-2 w-1/3 rounded-full"
              >
                Mac
              </button> */}
            </div>
          </div>
        </div>
        {/* <div
          className=" text-center login-container contentLogin z-10 bg-white border-1 border-grey-800 rounded-xl shadow-xl p-6 "
          style={{
            width: "450px",
            "min-height": "200px",
            "margin-top": "100px",
          }}
        >
          <div className="text-center font-bold text-xl mb-1 uppercase">
            Terima Kasih!
          </div>
          <div className="pb-4">
            Anda sudah berpartisipasi dalam tes ini. Silahkan klik tombol di
            bawah ini untuk menutup halaman tes.
          </div>

          <div>
            <div></div>
            <div className="">
              {hasilTes
                ? hasilTes.map((item) => {
                    if (parseInt(item.view_hasil) === 1) {
                      return (
                        <div
                          key={item.id}
                          className="border border-blue-400 text-blue-900 px-4 py-3 rounded mb-4"
                        >
                          <div>Skor {item.nama_projek}</div>
                          <div className="text-4xl">{item.jumlah_benar}</div>
                        </div>
                      );
                    }
                    return null;
                  })
                : ""}
            </div>
          </div>
          <NavLink
            to="/peserta/logout"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Keluar
          </NavLink>
        </div> */}
      <div className="w-1/4 h-screen">
        <img src={bobablock} className="absolute top-[10%] right-[0%] object-cover"></img>
      </div>
      </div>
    </div>
  );
};

export default Blocked;
